// Proposals graduated from beta on 2026-04-29 — any signed-in @fello.ai
// user can see and act on them. Google SSO already enforces the domain
// (hd=fello.ai on the OAuth call), so authentication alone is sufficient.
export function canSeeProposals(email: string | undefined | null): boolean {
  if (!email) return false;
  return email.toLowerCase().endsWith("@fello.ai");
}
